module.exports = __webpack_public_path__ + "static/media/ManageShipment.d0e1f630.svg";